<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">序时账</span>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <account-date-choose v-model="accountDate"/>
      </Cell>
    </Row>
    <Row class="h-panel-body" type="flex" :space-x="10">
      <Cell :flex="1">
        <!-- height绑定数字，修复Prop类型警告 -->
        <Table
            :datas="dataList"
            :border="true"
            :loading="loading"
            :height="630"
            @row-click="selectRow"
        >
          <TableItem title="日期" prop="voucherDate" :width="85" align="left"></TableItem>
          <TableItem title="凭证字号" :width="85" align="left">
            <template slot-scope="{data}">
              <router-link
                  v-if="data.word && data.voucherId"
                  :to="{name:'VoucherForm',params:{voucherId:data.voucherId}}"
              >
                {{data.word}}-{{data.code}}
              </router-link>
            </template>
          </TableItem>
          <TableItem title="摘要" prop="summary" align="left"></TableItem>
          <TableItem title="科目"  align="left" >
            <template slot-scope="{data}">
              <span v-if="data.subjectCode">{{data.subjectCode}}-{{data.subjectName}}</span>
            </template>
          </TableItem>
          <TableItem title="借方金额" align="right" :width="85" >
            <template slot-scope="{data}">
              {{data.debitAmount|numFormat}}
            </template>
          </TableItem>
          <TableItem title="贷方金额" align="right" :width="85" >
            <template slot-scope="{data}">
              {{data.creditAmount|numFormat}}
            </template>
          </TableItem>
          <!-- 全部替换为三元表达式，移除?.可选链 -->
          <TableItem title="客户名称"  align="left">
            <template slot-scope="{data}">
              <span>{{data.params ? data.params['客户名称'] : ''}}</span>
            </template>
          </TableItem>
          <TableItem title="供应商名称"  align="left">
            <template slot-scope="{data}">
              <span>{{data.params ? data.params['供应商名称'] : ''}}</span>
            </template>
          </TableItem>
          <TableItem title="职员名称"  align="left">
            <template slot-scope="{data}">
              <span>{{data.params ? data.params['职员名称'] : ''}}</span>
            </template>
          </TableItem>
          <TableItem title="部门名称"  align="left">
            <template slot-scope="{data}">
              <span>{{data.params ? data.params['部门名称'] : ''}}</span>
            </template>
          </TableItem>
          <TableItem title="存货名称"  align="left">
            <template slot-scope="{data}">
              <span>{{data.params ? data.params['存货名称'] : ''}}</span>
            </template>
          </TableItem>
          <TableItem title="制单人" prop="createMemberName" align="left"></TableItem>
          <TableItem title="审核人" prop="auditMemberName" align="left"></TableItem>
        </Table>
      </Cell>
    </Row>
  </app-content>
</template>

<script>
import {mapState} from "vuex";
import moment from "moment";

export default {
  name: "Sequence",
  data() {
    return {
      dataList: [],
      loading: false,
      showNumPrice: false,
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'name',
        dataMode: 'list',
        datas: []
      },
      accountDate: null,
      auxiliary: null,
      auxiliaryItem: null,
      auxiliaryType: [],
      selectedRow: null,
      requestLock: false // 请求锁，防止重复请求后端报错
    }
  },
  watch: {
    // 仅手动修改日期时触发加载，初始化赋值不重复请求
    accountDate(newVal, oldVal) {
      if (newVal && oldVal && newVal !== oldVal) {
        this.loadList();
      }
    },
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    date() {
      // 空值兜底，防止moment空值调用year报错
      return this.accountDate ? moment(this.accountDate) : moment();
    },
  },
  methods: {
    selectRow (item) {
      if (this.selectedRow === item) {
        this.selectedRow = null;
      } else {
        this.selectedRow = item;
      }
    },
    loadList() {
      // 请求锁拦截重复调用，解决后端「重复请求」报错
      if (this.requestLock) return;
      this.requestLock = true;
      this.loading = true;

      this.$api.voucher.loadVoucher({
        checked: [],
        year: this.date.year(),
        month: this.date.month() + 1,
        type: 2
      })
          .then(({data}) => {
            this.dataList = data;
          })
          .catch(err => {
            console.error('加载序时账失败：', err);
          })
          .finally(() => {
            this.loading = false;
            this.requestLock = false;
          });
    },
    loadAuxiliaryList() {},
    doSearch() {},
    doSelect(node) {}
  },
  created() {
    this.accountDate = this.currentAccountSets.currentAccountDate;
    this.loadList();
  },
}
</script>

<style scoped>
/* /deep/ 深度选择器适配Vue2旧版本穿透样式 */
/deep/ .table {
  max-height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid #0c6c8b;
  background-color: yellow;
}
</style>